import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SERVICES } from '../data/siteData';

export default function ServiceGrid({ limit }) {
  const services = limit ? SERVICES.slice(0, limit) : SERVICES;
  return (
    <div className="service-grid">
      {services.map((service) => {
        const Icon = service.icon;
        return (
          <Link className="service-card" to={`/services/${service.slug}`} key={service.slug}>
            <span className="service-card__icon"><Icon size={28} /></span>
            <h3>{service.title}</h3>
            <p>{service.short}</p>
            <span className="text-link">Learn more <ArrowRight size={16} /></span>
          </Link>
        );
      })}
    </div>
  );
}
